import { writable, derived } from "svelte/store";

export let email = writable("");
export let authFlow = writable("");
export let errors = writable({});
export let hasError = derived(
  errors,
  (errors) => Object.entries(errors).length
);
